import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h3`
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
  margin: 0;
`;

export const ViewAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.blueText};
`;

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FAQItemContainer = styled.div`
  background: ${theme.whiteText2};
  border-radius: 12px;
  padding: 14px 16px;
`;

export const FAQItemButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const QuestionText = styled.span`
  flex: 1;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.semiBold};
  color: ${theme.blackText};
  margin-right: 12px;
`;

export const AnswerText = styled.p`
  margin: 10px 0 0;
  font-size: 13px;
  color: ${theme.greyText};
  line-height: 1.6;
`;

export const ChevronWrapper = styled.span<{ $isExpanded: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "rotate(180deg)" : "rotate(0)"};
  color: ${theme.lightGreyText};
`;
